const STORAGE_KEY = "guffgaff_lists";

export const LIST_ITEMS = [
  { id: "watchlist",   label: "Watchlist",   icon: "🎬" },
  { id: "seen_it",     label: "Seen It",     icon: "✅" },
  { id: "favourites",  label: "Favourites",  icon: "❤️" },
  { id: "hidden_gems", label: "Hidden Gems", icon: "💎" },
];

export function getLists() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : {};
    const result = {};
    for (const { id } of LIST_ITEMS) {
      result[id] = Array.isArray(parsed[id]) ? parsed[id] : [];
    }
    return result;
  } catch {
    return Object.fromEntries(LIST_ITEMS.map(({ id }) => [id, []]));
  }
}

function saveLists(lists) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(lists));
}

export function addToList(listId, movie) {
  const lists = getLists();
  if (!lists[listId]) return;
  if (!lists[listId].some(m => m.id === movie.id)) {
    lists[listId].push({
      id:         movie.id,
      title:      movie.title,
      poster_url: movie.poster_url,
      year:       movie.year,
      score:      movie.score,
    });
    saveLists(lists);
  }
}

export function removeFromList(listId, movieId) {
  const lists = getLists();
  if (!lists[listId]) return;
  lists[listId] = lists[listId].filter(m => m.id !== movieId);
  saveLists(lists);
}

export function isInList(listId, movieId) {
  const lists = getLists();
  return (lists[listId] || []).some(m => m.id === movieId);
}
